export const STORE_NAME = "feedback";
export const STORE_VERSION = 2;
export const OBJECT_STORE_ANSWERS = "answers";
export const CATEGORY_RATING = "category_rating";
export const STORE_CURRENT_TIME = "current_time";
